import Axios from "axios"
import { useNavigate } from "react-router"
import Button from "consumer/custom/button"


export default function Apply(props) {

    const navigate = useNavigate()

    const verifyCheck = props['verifyCheck']
    const enrollCheck = props['enrollCheck']

    async function apply() {
        const payload = {}
        const field = document.querySelectorAll('[category="field"]:required')
        for(let i=0; i<field.length; i++) {
            const name = field[i]['name']
            const value = field[i]['value'].trim()
            const error = field[i].getAttribute('error')
            if(value === '') {
                return alert(error)
            }

            payload[name] = value
        }

        const field2 = document.querySelectorAll('[category="field"]:not([required])')
        for(let i=0; i<field2.length; i++) {
            const name = field2[i]['name']
            const value = field2[i]['value'].trim()

            payload[name] = value
        }

        if(window.confirm('신청하시겠습니까?')) {
            const result = await Axios
                            .post("/consumer/save", {
                                data: payload
                            })

            const data = result['data']
            if(data['status'] === 'fail') {
                alert(data['message'])
            }
            else if(data['status'] === 'success') {
                const consumer_id = data['data']['id']
                const payment = data['data']['payment']
                let next_url = '/step4'
                if(payment === 0) {
                    next_url = `/result?id=${consumer_id}`
                }
                navigate(next_url, {
                    state: {
                        consumer_id: consumer_id
                    },
                    replace: true
                })
            }
        }

        // const step3 = document.getElementById('step3')
        // const student_name = step3.querySelector('[name="student_name"]').value.trim()
        // const parent_phone = step3.querySelector('[name="parent_phone"]').value.trim()
        // let student_sex = step3.querySelector('[name="student_sex"]:checked')
        // if(student_sex) {
        //     student_sex = student_sex.value
        // }
        // else {
        //     student_sex = ''
        // }
        // const student_grade = step3.querySelector('[name="student_grade"]').value
        // const agree_person = step3.querySelector('[name="agree_person"]').checked

        // if(student_name === '') {
        //     alert('학생 이름을 입력해 주세요.')
        // }
        // else if(parent_phone === '') {
        //     alert('보호자 연락처를 입력해 주세요.')
        // }
        // else if(student_sex === '') {
        //     alert('학생 성별을 선택해 주세요.')
        // }
        // else if(student_grade === '') {
        //     alert('학생 학년을 선택해 주세요.')
        // }
        // else if(!agree_person) {
        //     alert('개인정보 수집 및 이용에 동의해 주세요.')
        // }
        // else if(!verifyCheck) {
        //     alert('문자 인증이 필요합니다.')
        // }
        // else if(window.confirm('신청하시겠습니까?')) {
        //     const branch_id = step3.querySelector('[name="branch_id"]').value
        //     const schedule_id = step3.querySelector('[name="schedule_id"]').value
        //     const address = step3.querySelector('[name="address"]').value
        //     const promotion = step3.querySelector('[name="agree_promotion"]').checked
        //     const verify_id = step3.querySelector('[name="verify_id"]').value

        //     const data = {
        //         branch_id: branch_id,
        //         schedule_id: schedule_id,
        //         student_name: student_name,
        //         parent_phone: parent_phone,
        //         student_sex: student_sex,
        //         student_grade: student_grade,
        //         address: address,
        //         enroll: enrollCheck,
        //         promotion: promotion,
        //         verify_id: verify_id
        //     }
        //     const result = await Axios
        //                     .post("/consumer/save", {
        //                         data: data
        //                     })

        //     const d = result['data']
        //     if(d['status'] === 'fail') {
        //         alert(d['message'])
        //     }
        //     else if(d['status'] === 'success') {
        //         const consumer_id = d['data']['id']
        //         const payment = d['data']['payment']
        //         let next_url = '/step4'
        //         if(payment === 0) {
        //             next_url = '/result'
        //         }
        //         navigate(next_url, {
        //             state: {
        //                 consumer_id: consumer_id
        //             },
        //             replace: true
        //         })
        //     }
        // }
    }

    return(
        <Button
            text="신청"
            style={{
                marginTop: "50px"
            }}
            event={{
                onClick: function() {
                    apply()
                }
            }}
        ></Button>
    )
}